'use strict';

module.exports = Odigeo.Widget.extend({
    modelClass: require('./model'),
    viewClass: require('./view'),
});
